import { useGetAllergyOptions } from "@/hooks/requests/medical/use-get-allergy-options";
import { useGetMedical } from "@/hooks/requests/medical/use-get-medical";
import { useEffect, useState } from "react";

/**
 * Hook to manage allergen options and their selection state.
 * Handles fetching available allergy options and the user's current allergies from medical data.
 *
 * @returns Object containing allergen options, loading state, and selected options
 */
export const useAllergenOptions = () => {
  const { data: allergyOptions, isLoading: isAllergyOptionsLoading } =
    useGetAllergyOptions();

  const { medical, isLoading: isMedicalLoading } = useGetMedical();

  const [selectedOptions, setSelectedOptions] = useState<Set<string>>(
    new Set(),
  );

  /**
   * Populate selected allergen options when data is fetched.
   * This ensures the UI reflects the user's existing allergy information.
   */
  useEffect(() => {
    if (allergyOptions && medical) {
      const selectedAllergens = allergyOptions.allergyOptions.filter((option) =>
        medical.allergies?.includes(option),
      );
      setSelectedOptions(new Set(selectedAllergens));
    }
  }, [allergyOptions, medical]);

  return {
    options: allergyOptions?.allergyOptions ?? [],
    isLoading: isAllergyOptionsLoading || isMedicalLoading,
    selectedOptions,
    setSelectedOptions,
  };
};
